import { render, staticRenderFns } from "./Verfication.vue?vue&type=template&id=02bd27ac&scoped=true&"
import script from "./Verfication.vue?vue&type=script&lang=js&"
export * from "./Verfication.vue?vue&type=script&lang=js&"
import style0 from "./Verfication.vue?vue&type=style&index=0&id=02bd27ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd27ac",
  null
  
)

export default component.exports